import { render, staticRenderFns } from "./FacebookPixelEditor.vue?vue&type=template&id=538ae980"
import script from "./FacebookPixelEditor.vue?vue&type=script&lang=js"
export * from "./FacebookPixelEditor.vue?vue&type=script&lang=js"
import style0 from "./FacebookPixelEditor.vue?vue&type=style&index=0&id=538ae980&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports